import { selector } from "./recoilSelectors";
import { companyFieldState, isSelfOperatorState, uidState } from "./accountState";
import { memberState } from "./membersState";
import { EMPTY_UID, Uid } from "../types/core";
import type { DispatchJobTeamVisibility } from "../constants/company";
import type { DispatchJobVisibilityRequest } from "../utils/dispatchJobVisibility";
import { getDispatchJobTeamVisibility, getDispatchJobVisibilityRequest } from "../utils/dispatchJobVisibility";

export const dispatchJobTeamVisibilityModeState = selector<DispatchJobTeamVisibility>({
    key: "dispatch.jobs.visibility.mode",
    get: ({ get }) => {
        if (!get(isSelfOperatorState)) {
            return getDispatchJobTeamVisibility(undefined);
        }
        return getDispatchJobTeamVisibility(get(companyFieldState("dispatcher_job_team_visibility")));
    },
});

export const dispatchCurrentMemberTeamIdsState = selector<number[]>({
    key: "dispatch.jobs.visibility.teams",
    get: ({ get }) => {
        const uid = get(uidState);
        if (!uid || uid === EMPTY_UID) {
            return [];
        }
        return get(memberState(uid as Uid))?.teams ?? [];
    },
});

export const dispatchJobVisibilityRequestState = selector<DispatchJobVisibilityRequest>({
    key: "dispatch.jobs.visibility.request",
    get: ({ get }) => {
        if (!get(isSelfOperatorState)) {
            return {
                active: false,
                teamIds: [],
                includeUnsetTeam: false,
            };
        }
        return getDispatchJobVisibilityRequest(
            get(dispatchJobTeamVisibilityModeState),
            get(dispatchCurrentMemberTeamIdsState),
        );
    },
});
